var map = {
	"./0.png": 881,
	"./1.png": 882,
	"./10.png": 883,
	"./11.png": 884,
	"./12.png": 885,
	"./13.png": 886,
	"./14.png": 887,
	"./15.png": 888,
	"./16.png": 889,
	"./17.png": 890,
	"./18.png": 891,
	"./19.png": 892,
	"./2.png": 893,
	"./3.png": 894,
	"./4.png": 895,
	"./5.png": 896,
	"./6.png": 897,
	"./7.png": 898,
	"./8.png": 899,
	"./9.png": 900
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 515;